import { createClient, type SupabaseClient, type User } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase environment variables not set. Using placeholder values for build.');
}

export const supabase: SupabaseClient = createClient(
  supabaseUrl || 'http://localhost:54321',
  supabaseAnonKey || 'placeholder-key'
);

export type { User, Session } from '@supabase/supabase-js';

/**
 * Current user read from the LOCAL session — no network round-trip.
 *
 * `supabase.auth.getUser()` hits `/auth/v1/user` on every call; with ~95 call
 * sites that made every route load fire 9–18 identical auth requests
 * (2026-07-02 network audit). The session user is the same object, and every
 * PostgREST/edge request is validated server-side by RLS anyway, so
 * client-side data fetching should resolve the user locally. `getSession()`
 * still auto-refreshes an expired access token, so long-lived tabs stay valid.
 */
export async function getSessionUser(): Promise<User | null> {
  const { data: { session } } = await supabase.auth.getSession();
  return session?.user ?? null;
}
